// SECTION 1: VARIABLES
export const APP_NAME = "StickyHQ Notes";
export const APP_TAGLINE = "Premium Notes and Sticky Boards";
export const DEFAULT_WORKSPACE_NAME = "Personal";
export const SHORTCUT_PALETTE = "CTRL+K";
export const SHORTCUT_NEW_NOTE = "CTRL+N";
export const SHORTCUT_FOCUS_MODE = "CTRL+SHIFT+F";
export const STORAGE_ENGINE = "indexeddb";
export const ENABLE_MOTION = true;
export const MOTION_LEVEL = "premium";

// AUTH & SESSION CONSTANTS
export const DEFAULT_SCRIPT_WEB_APP_URL = "https://script.google.com/macros/s/AKfycbzFSS43FKGfJr6nkBcShKXPw32DZV0mL6eZkQoUKIS7JM0geRF9STm6gENevaK5oJuKmA/exec";
export const SCRIPT_WEB_APP_URL_KEY = "stickyhq_script_url_v1";
export const SESSION_STORAGE_KEY = "stickyhq_session_v1";
export const CLIENT_ID_STORAGE_KEY = "stickyhq_client_id_v1";
export const LOGIN_VIEW_ID = "login";
export const DEFAULT_VIEW_AFTER_LOGIN = "dashboard";
export const ALLOW_CMD_K_ON_LOGIN = true;

// VIEW IDS
export const APP_VIEW_DASHBOARD = "dashboard";
export const APP_VIEW_BOARD = "board";
export const APP_VIEW_LIST = "list";
export const APP_VIEW_TIMELINE = "timeline";
export const APP_VIEW_SETTINGS = "settings";
export const APP_VIEW_BACKUP = "backup";
export const DEFAULT_SPACE_VIEW = APP_VIEW_BOARD;
export const RANK_MODE = "stars";
export const MAX_IMAGE_MB = 3;
export const LARGE_FILE_WARNING_MB = 5;
export const MAX_FILE_MB = 50;

// PRODUCTIVITY CONSTANTS
export const AUTO_DASHBOARD_RANGE_DAYS = 7;
export const DASHBOARD_STALE_DAYS = 30;
export const DASHBOARD_MAX_ITEMS_PER_SECTION = 8;
export const AUTO_TAG_SUGGESTION_LIMIT = 8;
export const AUTO_TAG_MIN_TOKEN_LEN = 4;
export const ARCHIVE_ENABLED = true;
export const ARCHIVE_RETENTION_DAYS = 90;
export const QUICK_CAPTURE_DEFAULT_TYPE = "text";
export const QUICK_CAPTURE_AUTO_SAVE_MS = 400;
export const PREFERENCES_STORAGE_KEY = "stickyhq_prefs_v1";

// SYNC CONSTANTS
export const SYNC_ENABLED_DEFAULT = true;
export const SYNC_AUTO_ON_ACTIVATION = true;
export const SYNC_AUTO_DEBOUNCE_MS = 1200;
export const SYNC_THROTTLE_MINUTES = 3;
export const SYNC_SETTINGS_STORAGE_KEY = "stickyhq_sync_settings_v1";
export const SYNC_STATE_STORAGE_KEY = "stickyhq_sync_state_v2";
export const DEFAULT_SYNC_MODE = "two_way";
export const DEFAULT_CONFLICT_POLICY = "newer_wins";
export const DEFAULT_API_KEY_REQUIRED = false;
export const BULK_ACTIONS_ENABLED = true;
export const AUTO_BACKUP_FREQUENCY = "daily";
export const AUTO_BACKUP_KEEP_DAYS = 14;
export const ENABLE_BULK_PERMANENT_DELETE = true;

export const DEFAULT_NOTE_COLORS = [
  { key: "sun", label: "Sun", hex: "#F8D66D" },
  { key: "mint", label: "Mint", hex: "#A7F3D0" },
  { key: "sky", label: "Sky", hex: "#93C5FD" },
  { key: "rose", label: "Rose", hex: "#FDA4AF" },
  { key: "slate", label: "Slate", hex: "#CBD5E1" },
  { key: "white", label: "White", hex: "#FFFFFF" }
];

export const DB_NAME = "StickyHQ_DB";
export const DB_VERSION = 2;